module.exports = __webpack_public_path__ + "images/automatic-scouts/congrats-2785cbeee152363750462558eb17bb6e.png";